!function(){"use strict";angular.module("scApp.comun",["ngMessages"])}();